import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { from, Subject } from 'rxjs';
import { StepIds } from '../../../../models/property-step/property-step-model';
import { PropertySectionBase } from '../../../property-section-base';
import {
    IRouterData,
    RouterFacade,
    DraftFacade
} from '@classifieds-sell/state';
import { takeUntil } from 'rxjs/operators';
import { LifeStyleSubCategoryEnum } from '@classifieds-sell/datalayer';

@Component({
    selector: 'property-summary-page-agent-property-description-section',
    templateUrl: './summary-page-property-description-section.component.html',
    styleUrls: ['./summary-page-property-description-section.component.scss']
})
export class LifeStyleSummaryPagePropertyDescriptionSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;

    listingTitle: string;
    viewingInstructions: string;
    amenities: string;
    agencyReference: string;
    routerData: IRouterData;
    isDwellingSubcategory: boolean;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: DraftFacade,
        public routerFacade: RouterFacade,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.getRouteData();
            this.listingTitle = this.draftData.propertyDescription.title;
            this.viewingInstructions = this.draftData.propertyDescription.viewingInstructions;
            this.amenities = this.draftData.propertyDescription.amenities;
            this.agencyReference = this.draftData.propertyDescription.agencyReference;
            this._changeDetectorRef.markForCheck();
        });
    }

    getRouteData(): void {
        from(this.routerFacade.routerData$)
            .pipe(takeUntil(this._destroyed$))
            .subscribe((routerStateData) => {
                this.routerData = routerStateData;
                this.isDwellingSubcategory = this.routerData.subCategory === LifeStyleSubCategoryEnum.dwelling;
            });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
